import React, { Component } from 'react';
import { Input, Row, Col, Card, Divider, Button } from 'antd'
import { getCustomer } from '../../services/customer';
import { withRouter, useParams } from 'react-router-dom';
import { isEmptyObj, renderStringValue } from '../../utils';
import SingleMarkerMap from '../../components/singleMarkerMap/SingleMarkerMap';
import CustomerProductList from '../../components/customerProduct/CustomerProductList';
import CustomerBucketList from '../../components/customerBucket/CustomerBucketList';
import { PushpinOutlined } from '@ant-design/icons';

const { Search } = Input;

class CustomerDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            customer: {},
            dataLoading: false
        }
        this.getData = this.getData.bind(this);
        this.onBackClicked = this.onBackClicked.bind(this);
    }

    async onBackClicked() {
        const { history, routeId } = this.props;
        history.push(`/routes/${routeId}`)
    };

    async getData() {
        this.setState({
            dataLoading: true
        }, async () => {
            const { id } = this.props
            const res = await getCustomer(id)
            const customer = res.data.customer
            this.setState({
                customer,
                dataLoading: false
            })
        })
    }

    componentWillMount() {
        this.getData()
    }

    render() {
        const { customer } = this.state

        return (
            <div>
                <Divider orientation="center"><span className='name-header'>{customer.name}</span></Divider>
                <Row>
                    <Col span={24}>
                        <Card>
                            <Row>
                                <Col xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
                                    <p>รายละเอียด:</p>
                                </Col>
                                <Col xs={20} sm={20} md={20} lg={20} xl={20} xxl={20}>
                                    <p>{renderStringValue(customer.description)}</p>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Divider orientation="center">ถังลูกค้า: {customer.total_bucket}</Divider>
                <Row style={{backgroundColor: 'white', paddingLeft: 24, paddingRight: 24}}>
                    <Col span={24}>
                        <CustomerBucketList data={customer.buckets}/>
                    </Col>
                </Row>
                <Divider orientation="center">สินค้าที่ลง: {customer.total_sack}</Divider>
                <Row style={{backgroundColor: 'white', paddingLeft: 24, paddingRight: 24}}>
                    <Col span={24}>
                        <CustomerProductList data={customer.product_sales}/>
                    </Col>
                </Row>
                <Divider orientation="center">แผนที่</Divider>
                <div style={{ display: 'flex', height: 200, width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                    <Button type="primary" size="large" onClick={() => window.open(`http://maps.google.co.th/maps?q=${customer.lat},${customer.lng}`, '_blank').focus()}>ดูแผนที่<PushpinOutlined /></Button>
                </div>
                {/* {!isEmptyObj(customer) && <Row>
                    <SingleMarkerMap markerPos={{lat: Number(customer.lat), lng: Number(customer.lng)}} customerName={customer.name}/>
                </Row>} */}
                <Row gutter={12} style={{marginTop: 15}}>
                    <Col span={24} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Button type="default" size="large" onClick={this.onBackClicked}>กลับ</Button>
                    </Col>
                </Row>
            </div>
        );
    }
}

function pathParamHook(Component) {
    return function WrappedComponent(props) {
      const { id, routeId } = useParams();
      return <Component {...props} id={id} routeId={routeId} />;
    }
}

export default withRouter(pathParamHook(CustomerDetail));